import './App.css';

import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";


import { Home } from './components/home/home';
import { Lending } from './components/lending/lending';
import { Pay } from './components/Pay/pay';
import { Personal } from './components/personal/personal';
import { Login } from './components/login/login';

import { MAIN_ROUTE } from './static/vars';
import { Buy } from './components/Buy/buy';
import { Prolong } from './components/lending/prolong';
import { Success } from './components/home/success';
import { Error } from './components/home/error';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path={MAIN_ROUTE + "/:a/:b/:c"}
                    // path="/strahovanie-ipoteky/:a/:b/:c"
                    element={
                        <Home
                        />
                    }
                />
                <Route
                    path={MAIN_ROUTE ? MAIN_ROUTE : "/"}
                    // path="/strahovanie-ipoteky"
                    element={
                        <Home
                        />
                    }
                />
                <Route
                    path="/strahovanie-ipoteky/manager"
                    element={<Lending />}
                />
                <Route
                    path={MAIN_ROUTE + "/success"}
                    element={<Success />}
                />
                <Route
                    path={MAIN_ROUTE + "/error"}
                    element={<Error />}
                />
                <Route
                    path={MAIN_ROUTE + "/manager/prolong"}
                    element={<Prolong/>}
                />
                <Route
                    path={MAIN_ROUTE + "/pay/:n1/:n2/:s1/:s2"}
                    element={
                        <Pay />
                    }
                />
                <Route
                    path={MAIN_ROUTE + "/personal"}
                    element={
                        <Personal />
                    }
                />
                <Route
                    path={MAIN_ROUTE + "/login"}
                    element={
                        <Login />
                    }
                />
                <Route
                    path={MAIN_ROUTE + "/buy/:id"}
                    element={
                        <Buy />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
